<div class="d-flex flex-column gap-4 p-3 w-100 bg-white">

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center pb-3 border-bottom border-2">
    <div class="fs-5 fw-bold">Provider Locations</div>

    <button class="btn btn-light d-flex align-items-center gap-2" (click)="goTo('/instant-rate-manager')">
      <i class="bi bi-arrow-left"></i>
      Back to Instant Rate Manager
    </button>
  </div>

  <!-- Tabs / Navbar -->
  <nav class="w-100 overflow-x-auto">
    <ul class="nav nav-tabs border-0 gap-2 flex-nowrap" style="min-width: max-content;">

      <li class="nav-item">
        <button class="nav-link d-flex align-items-center gap-2 px-4 py-3 text-nowrap" [class.active]="activeTab === 'locations'"
          (click)="setActiveTab('locations')">
          <i class="bi bi-geo-alt"></i>
          Manage Locations
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link d-flex align-items-center gap-2 px-4 py-3 text-nowrap" [class.active]="activeTab === 'depots'"
          (click)="setActiveTab('depots')">
          <i class="bi bi-building"></i>
          Manage Depots
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link d-flex align-items-center gap-2 px-4 py-3 text-nowrap"
          [class.active]="activeTab === 'configuration'" (click)="setActiveTab('configuration')">
          <i class="bi bi-gear"></i>
          Manage Configuration
        </button>
      </li>

    </ul>
  </nav>

  <div class="tab-content w-100">
    <div *ngIf="activeTab === 'locations'">
      <app-manage-locations></app-manage-locations>
    </div>
    <div *ngIf="activeTab === 'depots'">
      <app-manage-depots (noZonesFound)="setActiveTab('locations')"></app-manage-depots>
    </div>
    <div *ngIf="activeTab === 'configuration'">
      <app-manage-configurations></app-manage-configurations>
    </div>
  </div>



</div>
